// saga.js
import { all, takeEvery, put } from 'redux-saga/effects';
import profileActions from './actions';
import authActions from '../auth/actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');

const headers = () => ({
  Authorization: localStorage.getItem('access_token'),
  AuthId: localStorage.getItem('id_token'),
});

function* fetchProfileDataEffect() {
  try {
    const res = yield gaxios.request({
      url: 'api/users/' + localStorage.getItem('id_token'),
      headers: headers(),
    });

    yield put(profileActions.fetchProfileDataSuccess(res.data));
  } catch (error) {
    console.log(error)
    yield put(profileActions.fetchProfileDataFailure(error));
  }
}

function* actualizarPerfil(action) {
  try {
    const res = yield gaxios.request({
      url: 'api/users/' + action.payload._id,
      method: "PUT",
      data: action.payload,
      headers: headers(),
    });
    if (res.data.success) {
      notification('success', res.data.msg)
      yield put({
        type: profileActions.SET_PROFILE_DATA,
        profile: res.data.user
      });
      yield put({
        type: authActions.UPDATE_LOGIN_INFO,
        profile: res.data.user
      });

    }
  } catch (error) {
    yield put(profileActions.fetchProfileDataFailure(error));
  }
}

function* getNotificaciones(action) {
  try {
    const query = action.query ? `?${action.query}` : '';
    let ULRDestino = 'api/notificaciones/' + query;

    const res = yield gaxios.request({
      url: ULRDestino,
      method: "GET",
      headers: headers(),
    });

    if (res.data.success) {
      // notification('success', res.data.msg);

      yield put({
        type: profileActions.SET_NOTIFICACIONES,
        payload: res.data
      });
    }

  } catch (error) {
    yield put(profileActions.fetchProfileDataFailure(error));
  }
}

function* updateNotificaciones(action) {
  try {
    console.log("Accion: ", action);
    const urlDestino = !action.idNotificacion
      ? 'api/notificaciones/'
      : 'api/notificaciones/' + action.idNotificacion;

    const res = yield gaxios.request({
      url: urlDestino,
      method: "PUT",
      data: action.payload,
      headers: headers(),
    });

    if (res.data.success) {
      //notification('success', res.data.msg);
      yield put({
        type: profileActions.SET_NOTIFICACIONES,
        payload: res.data
      });
    }

  } catch (error) {
    yield put(profileActions.fetchProfileDataFailure(error));
  }
}

export default function* profileSaga() {
  yield all([
    takeEvery(profileActions.FETCH_PROFILE_DATA_START, fetchProfileDataEffect),
    takeEvery(profileActions.FETCH_PROFILE_DATA_UPDATE, actualizarPerfil),
    takeEvery(profileActions.GET_NOTIFICACIONES, getNotificaciones),
    takeEvery(profileActions.UPDATE_NOTIFICACIONES, updateNotificaciones),
  ]);
}
